<template>
    <NotificationTile @click="tileClicked" :isNotificationRead="isNotificationRead">

        <template v-slot:icon>
            <TileIcon :size="50">
                <SafeImage :src="notification.body.icon"></SafeImage>
            </TileIcon>
        </template>



        <template v-slot:title>{{ notification.body.payoutName }} ({{ notification.body.state }})</template>
        <template v-slot:description>{{ formatTime(notification.createdAt) }}</template>



        <template v-slot:coins>
            {{ notification.body.currencyAmount }}
        </template>


        <template v-slot:chip-icon>
            <money-icon></money-icon>
        </template>

    </NotificationTile>
</template>



<script lang="ts">

import { useRouter } from 'vue-router';
import { formatDistanceToNow } from 'date-fns';
import { defineComponent, PropType, computed } from 'vue';


import MoneyIcon from '@/icons/Money.vue';
import TileIcon from '@/components/Common/Tile-Icon.vue';
import SafeImage from '@/components/Common/SafeImage.vue';
import IPayoutNotification from '@/interfaces/Notifications/IPayoutNotification';
import NotificationTile from '@/components/Tiles/Notification/NotificationTile.vue';

export default defineComponent({
    name: 'IPayoutNotificationTile',
    components: {
        TileIcon,
        MoneyIcon,
        SafeImage,
        NotificationTile,
    },
    props: {
        notification: {
            type: Object as PropType<IPayoutNotification>,
            required: true,
        },
    },
    setup(props) {
        const router = useRouter();

        const isNotificationRead = computed(() => {
            return props.notification.readAt != null;
        });

        const formatTime = (time: number) => {
            return formatDistanceToNow(time * 1000) + ' ago';
        }

        const tileClicked = () => {
            router.push('/reward/myRewardsList');
        };

        return {
            formatTime,
            tileClicked,
            isNotificationRead,
        };
    },
});

</script>